<template>
  <section class="section full-height">
    <admin-section-header icon="view-grid" title="Negocios" />
    <div class="tile is-ancestor full-width is-vertical height-100">
      <div class="tile is-parent is-horizontal">
        <dashboard-banner-tile
          :title="$t('Cuenta Business WI··')"
          subtitle=""
          :ctaText="$t('Apertura de cuenta Business')"
          ctaTarget="https://ecobanka.com/cuenta-business-wi%c2%b7%c2%b7/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-modern-business-buildings%202.jpg"
        ></dashboard-banner-tile>
        <dashboard-banner-tile
          :title="$t('Plataforma Corporativa WI··')"
          :ctaText="$t('Solicitar Tarjeta wI--')"
          ctaTarget="https://ecobanka.com/negocios/plataforma-corporativa-wi%c2%b7%c2%b7/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-businesswoman-using-tablet-to-analysis-graph-company-finance-strategy-statistics-success-concept-and-planning-for-future-in-office-room.jpg"
        ></dashboard-banner-tile>
        <dashboard-banner-tile
          :title="$t('Tarjeta Débito Business WI··')"
          :ctaText="$t('Solicitar Tarjeta Business wI--')"
          ctaTarget="https://ecobanka.com/tarjeta-debito-business-wi%c2%b7%c2%b7/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-credit-card-gbdcaea6f3_1920.jpg"
        ></dashboard-banner-tile>
      </div>
      <div class="tile is-parent is-4 is-horizontal">
        <dashboard-banner-tile
          :title="$t('EBURY')"
          :ctaText="$t('Acceso Operativas internacionales')"
          ctaTarget="#"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-primer-plano-tarjeta-credito-telefono-inteligente-manos-mujer.jpg"
        ></dashboard-banner-tile>
      </div>
    </div>
  </section>
</template>

<script>
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import DashboardBannerTile from '@/components/admin/dasboard/DashboardBannerTile.vue'
export default {
  name: 'Business',
  components: {
    AdminSectionHeader,
    DashboardBannerTile
  },
  computed: {},
  data() {
    return {}
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'Negocios'],
      title: 'Negocios'
    })
  }
}
</script>

<style lang="scss" scoped>
button.is-large {
  width: max-content;
  height: max-content;
}
.button-grid button {
  margin: 10px 10px;
  border-color: var(--rosa-dark-eco);
}
</style>
